import React from "react";
import { Button, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Utils from "~/helpers/Utils";

function maskPhone(phone) {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");

  // Brazilian numbers: country code 55 + 2-digit area code + 8-9 digit local number
  if (digits.startsWith("55") && digits.length >= 12) {
    const withoutCountry = digits.slice(2);
    const areaCode = withoutCountry.slice(0, 2);
    const local = withoutCountry.slice(2);
    const firstDigit = local[0];
    const lastFour = local.slice(-4);
    const maskedMiddle = "x".repeat(Math.max(0, local.length - 5));
    return `(${areaCode}) ${firstDigit}${maskedMiddle}-${lastFour}`;
  }

  // Generic fallback: show last 4 digits masked
  const lastFour = digits.slice(-4);
  const masked = "x".repeat(Math.max(0, digits.length - 4));
  return `${masked}-${lastFour}`;
}

export default function DialogVerifyAccess({ onClose }) {
  const { t } = useTranslation();
  const { business } = useSelector((store) => store?.business);
  const { user } = useSelector((store) => store?.auth);
  const meStore = useSelector((store) => store?.me?.me);
  const me = Utils.safeParseJSON("@prit-web/meData", meStore);
  const currentUser = me || meStore || user || {};
  const history = useHistory();

  const rawPhone = currentUser?.phone || currentUser?.phoneUnverified || "";
  const maskedPhone = maskPhone(rawPhone);

  const handleEnterWithAnotherNumber = () => {
    if (typeof onClose === "function") onClose();
    const route = business?.id ? `/business/link/${business.id}` : "/business/link";
    history.push(route);
  };

  return (
    <div style={{ padding: "0 20px 20px 20px", maxWidth: 480, margin: "0 auto" }}>
      <header style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: 20,
        textAlign: "center",
      }}>
        <Typography
          style={{
            fontWeight: 700,
            fontSize: "clamp(24px, 3vw, 30px)",
            textAlign: "center",
            marginBottom: 16,
            color: "#333333",
          }}
        >
          {t("Enter with the reservation number")}
        </Typography>

        <Typography
          style={{
            fontSize: "clamp(14px, 2vw, 18px)",
            textAlign: "center",
            color: "#666666",
            lineHeight: 1.5,
          }}
        >
          {t("You are connected as phone To see this reservation enter the number used when booking", { phone: maskedPhone })}
        </Typography>
      </header>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Button
          onClick={handleEnterWithAnotherNumber}
          style={{
            width: "100%",
            backgroundColor: "white",
            color: "black",
            textTransform: "none",
            fontWeight: "normal",
            padding: "8px",
            borderRadius: 20,
            fontSize: "clamp(16px, 2vw, 20px)",
            border: "1px solid rgba(0,0,0,0.3)",
            boxShadow: "none",
            height: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ flexGrow: 1, textAlign: "center" }}>
            {t("Enter with another number")}
          </span>
        </Button>
      </div>
    </div>
  );
}
